import { useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { getSVGImageUrl } from 'lib/image/imageUtils'
import GeoContext from 'contexts/geoContext'
import config from 'constants/config'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import type { PageBannerCarouselItem } from 'LuxKit/Banners/types'

const atolIconSrc = getSVGImageUrl('984lj4elpskyg828z90qb')

function useAtolBannerItem(): PageBannerCarouselItem | null {
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)
  const isTripPlannerEnabled = !!config.ENABLE_TRIP_PLANNER
  const isMobile = useScreenSizeOnly('mobile')

  return useMemo(() => {
    if (!isMobile || currentRegionCode !== 'GB' || !isTripPlannerEnabled) return null

    return {
      id: 'atol-protected',
      kind: 'informational-primary',
      icon: <img src={atolIconSrc} width="16" height="16" alt="" />,
      children: intl.formatMessage({
        id: 'f3QcmvhhtJ8F0JFo52wW',
        defaultMessage: 'ATOL protected',
        description: 'ATOL protection banner message in the insurance or protection selection',
      }),
    }
  }, [isMobile, currentRegionCode, isTripPlannerEnabled, intl])
}

export default useAtolBannerItem
